class NotifDel {
    show_wnd() {
        this.wnd.el.find('.date').val(sadd.find('input[name="date"]').val());
        this.wnd.el.find('.card_form').show();
        this.wnd.el.find('.form_result').hide();
        this.wnd.el.find('.studio_id').val(sadd.find('select[name="studio_id"]').val());
        show_window('notif_del');
    }
    hide_layer() {
        this.layer.el.hide('slide',{},400);
    }
    constructor(el) {
        this.el= el;
        this.layer = {};
        this.layer.el = this.el.find('.notif_del_layer');
        this.layer.close = this.layer.el.find('.close');
        this.btn_show = this.el.find('.btn_notif_del');
        this.wnd = {};
        this.wnd.el = this.el.find('.window[rel="notif_del"]');
        this.wnd.btn_ok = this.wnd.el.find('.form_button.ok');
        this.wnd.btn_finish = this.wnd.el.find('.form_button.finish');
        this.wnd.error = this.wnd.el.find('.error');

        this.btn_show.on('click', ()=>{
            this.show_wnd();
        });
        this.wnd.btn_ok.on('click', ()=>{
            this.wnd.btn_ok.formbutton('start');
            this.wnd.error.html('');
            $.post('/ajax/schedule/notif_del', {
                date: this.wnd.el.find('.date').val(),
                time_from: this.wnd.el.find('.time_from').val(),
                time_to: this.wnd.el.find('.time_to').val(),
                email: this.wnd.el.find('.email').val(),
                studio_id: this.wnd.el.find('.studio_id').val()
            }, (r) => {
                let a = jQuery.parseJSON(r);
                this.wnd.btn_ok.formbutton('stop');
                if (a['status']==='ok') {
                    this.wnd.el.find('.card_form').hide();
                    this.wnd.el.find('.form_result').show();
                } else {
                    this.wnd.error.html(a['message']);
                }
            });
        });
        this.wnd.btn_finish.on('click', () => {
            close_windows();
        });

        this.layer.close.on('click', ()=>{
            this.hide_layer();
        });

        this.layer.el.find('.btn').on('click', () => {
            this.hide_layer();
            this.show_wnd();
        });

        setTimeout(()=>{
            $.cookie('notif_del',1);
            this.layer.el.show('slide',{},400);
        },4000);
    }
}
$(function(){
    let notif_del = new NotifDel($('.notif_del'));
});